import {Component, ContentChild, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {ChannelingDashboardActions} from '../../../../administration/administration-shared/models/enums.models';

@Component({
	selector: 'amd-administration-panel-item',
	templateUrl: './administration-panel-item.component.html',
	styleUrls: ['./administration-panel-item.component.scss'],
	animations: [
		trigger('marginCounterAnimations', [
			state('base', style({})),
			state('hide', style({})),
			state('shorten', style({})),
			state('stretch', style({margin: '0'})),
			transition('* => *', animate('600ms')),
		]),
		trigger('counterAnimations', [
			state('base', style({opacity: 1, visibility: 'visible'})),
			state('hide', style({opacity: 0, height: '0px', visibility: 'hidden', margin: '0', padding: '0', overflow: 'hidden'})),
			state('shorten', style({
				opacity: 0,
				width: '0px',
				height: '0px',
				visibility: 'hidden',
				margin: '0',
				padding: '0',
				overflow: 'hidden'
			})),
			state('stretch', style({opacity: 1, visibility: 'visible', width: '100%', margin: '0'})),
			transition('* => *', animate('600ms')),
		])
	]
})
export class AdministrationPanelItemComponent implements OnInit {

	@Input() iconClass: string;
	@Input() inLineStyle: boolean = false;
	@Input() styleColor: AdministrationPanelItemStyles;
	@ContentChild('titleSubtitle') titleSubtitleRef: TemplateRef<any>;
	@Input() value: string = '0';
	@Input() action: ChannelingDashboardActions;
	@Output() onClick: EventEmitter<ChannelingDashboardActions> = new EventEmitter<ChannelingDashboardActions>();
	@Input() isCount: boolean = true;
	stepCounto: string = '1';
	startCounto: string = '0';
	duration: string = '0.1';
	currentvalue: number = 0;

	constructor() {
	}

	ngOnInit(): void {
	}

	updateCurrentValue(value: string): void {
		this.currentvalue = parseInt(value, 10);
	}
}

export enum AdministrationPanelItemStyles {
	ACCENT = 'amd-items-counter--accent',
	PRIMARY = 'amd-items-counter--primary',
	SECONDARY = 'amd-items-counter--secondary'
}
